import React, { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from 'store/hooks';
import { mappingURLToExternal } from 'utils/functions';

interface Props {
  seoData?: SEODataTypes;
  ogData?: OpenGraphDataTypes;
}

const HelmetComponent: React.FC<Props> = ({ seoData, ogData }) => {
  const location = useLocation();
  const seoGeneral = useAppSelector((state) => state.system.dataSystem?.seo);
  const dataOgSystem = useAppSelector((state) => state.system.dataSystem?.og);
  const { initializedGA } = useAppSelector((state) => state.system);

  //* GA
  useEffect(() => {
    if (initializedGA && location) {
      // ReactGA.pageview(
      //   location.pathname + location.search,
      //   undefined,
      //   seoData?.title || seoGeneral?.title,
      // );
      ReactGA.send({ hitType: 'pageview', page: location.pathname + location.search, title: seoData?.title || seoGeneral?.title });
    }
  }, [initializedGA, location, seoData, seoGeneral]);

  return (
    <Helmet>
      <title>{seoData?.title || seoGeneral?.title}</title>
      <meta
        name="description"
        content={seoData?.description || seoGeneral?.description}
      />
      <meta name="keyword" content={seoData?.keywords || seoGeneral?.keyword} />
      <meta name="og:url" property="og:url" content={window.location.href} />
      <meta
        name="og:title"
        property="og:title"
        content={ogData?.ogTitle || dataOgSystem?.title}
      />
      <meta
        name="og:description"
        property="og:description"
        content={ogData?.ogDescription || dataOgSystem?.description}
      />
      <meta
        name="og:image"
        property="og:image"
        content={mappingURLToExternal(ogData?.ogImage || dataOgSystem?.image)}
      />
      <meta
        name="og:type"
        property="og:type"
        content={ogData?.ogType || dataOgSystem?.type}
      />
      <meta
        name="twitter:title"
        content={seoData?.title || seoGeneral?.title}
      />
      <meta
        name="twitter:description"
        content={seoData?.description || seoGeneral?.description}
      />
      <meta
        name="twitter:image"
        content={mappingURLToExternal(seoData?.imgSrc || seoGeneral?.imgSrc)}
      />
    </Helmet>
  );
};

HelmetComponent.defaultProps = {
  seoData: undefined,
  ogData: undefined,
};

export default HelmetComponent;
